import { atom, useSetRecoilState } from "recoil";

export interface ImageViewResult {
    description?: string;
}
export interface ImageViewerOptions {
    description: string;
    name: string;
    lastModified: string;
    size: string;
    creator: string;
    readonly: boolean;
}
export interface ImageViewer {
    show: (base64: string | null, options?: ImageViewerOptions) => Promise<ImageViewResult>;
}
export const imageViewerAtom = atom({
    key: "imageViewerAtom",
    default: {
        base64: null as string | null,
        options: undefined as ImageViewerOptions | undefined,
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onClose: (description?: string) => {},
    },
});
export const useImageViewer = (): ImageViewer => {
    const setViewerState = useSetRecoilState(imageViewerAtom);
    const show = async (base64: string | null, options?: ImageViewerOptions): Promise<ImageViewResult> => {
        return new Promise<ImageViewResult>((resolve, reject) => {
            const onClose = (description?: string) => {
                // eslint-disable-next-line @typescript-eslint/no-empty-function
                setViewerState({ base64: null, options: undefined, onClose: () => {} });
                resolve({ description });
            };
            setViewerState({ base64, options, onClose });
        });
    };

    return { show };
};
